import { render, staticRenderFns } from "./echartWindSpeed.vue?vue&type=template&id=b99975f8&"
import script from "./echartWindSpeed.vue?vue&type=script&lang=js&"
export * from "./echartWindSpeed.vue?vue&type=script&lang=js&"
import style0 from "./echartWindSpeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports